export default {
  v3OfficialTopUpCenterTitle: 'Oficjalne Centrum Doładowań',
  v3OfficialTopUpCenterKeyword: 'Oficjalne Centrum Doładowań',
  v3OfficialTopUpCenterDescription: 'Oficjalne Centrum Doładowań',
  v3SafeAndFast: 'Bezpieczne, bez ryzyka i z natychmiastowym dodaniem środków',
  v3Shop: 'Sklep',
  v3ShoppingCart: 'Koszyk',
  v3MembershipCenter: 'Centrum Przywilejów (Centrum Premium)',
  v3Login: 'Logowanie',
  v3Account: 'Konto',
  v3EnterAccountName: 'Wprowadź nazwę konta',
  v3Password: 'Hasło',
  v3EnterPassword: 'Wprowadź hasło',
  v3ForgotPassword: 'Zapomniałem hasło',
  v3EnterUID: 'Wprowadź UID',
  v3OTP: 'OTP',
  v3EnterOTP: 'Proszę wprowadzić OTP',
  v3SelectTopUpCharacter: 'Wybierz postać do doładowania',
  v3SelectServer: 'Wybierz serwer',
  v3Confirm: 'Potwierdź',
  v3CharacterNotFound:
    'Jeśli nie możesz znaleźć postaci, spróbuj najpierw zalogować się do postaci w grze, a następnie zaloguj się do strony doładowań lub skontaktuj się z obsługą klienta.',
  v3Logout: 'Wyloguj',
  v3SwitchAccount: 'Zmień konto',
  v3MyCoupons: 'Moje kupony',
  v3BenefitsCenter: 'Centrum Przywilejów',
  v3TopUpBenefits: 'Zalety doładowania',
  v3MoreSettings: 'Więcej ustawień',
  v3RememberLoginStatus: 'Zapamiętaj mój status logowania',
  v3OrderQuery: 'Sprawdź zamówienia',
  v3ContactCustomerService: 'Obsługa klienta',
  v3LoginWithApp: 'Zaloguj się przez aplikację',
  v3ChooseOtherLoginMethod: 'Wybierz alternatywną metodę logowania',
  v3ConnectingToGameApp: 'Łączenie z aplikacją gry',
  v3EnsureGameInstalled:
    'Upewnij się, że gra jest zainstalowana na tym urządzeniu. Jeśli gra nie reaguje lub logowanie się nie powiodło, zaktualizuj grę do najnowszej wersji ze sklepu z aplikacjami lub przełącz się na inną przeglądarkę.',
  v3OpenGame: 'Uruchom grę',
  v3DownloadGame: 'Pobierz grę',
  v3UpdateGameIfOpenFails:
    'Jeśli gra nie uruchamia się, zaktualizuj ją do najnowszej wersji z App Store/Google Play.',
  v3ClickToDownloadLatestVersion:
    'Alternatywnie, możesz nacisnąć przycisk „pobierz grę”, aby pobrać najnowszą wersję.',
  v3LoggingIntoOfficialTopUpCenter:
    'Logujesz się do [Oficjalnego Centrum Doładowań]',
  v3CurrentAccount: 'Bieżące konto: xxxxxxxxxx',
  v3WelcomeToOfficialTopUpCenter: 'Witamy w Oficjalnym Centrum Doładowań',
  v3OfficialAuthorizedLogin:
    'Oficjalnie autoryzowane logowanie. Brak ryzyka bezpieczeństwa.',
  v3TermsOfService: 'Regulamin',
  v3PrivacyPolicy: 'Polityka prywatności',
  v3ThirdPartySocialAccountDescription:
    'O koncie społecznościowym strony trzeciej',
  v3BindSocialAccountInGameFirst:
    'Najpierw ukończ powiązanie swojego konta społecznościowego w centrum użytkownika w grze, a następnie zaloguj się z powiązanym kontem społecznościowym.',
  v3FirstTopUp15PercentOff: 'Zyskaj do 15% zniżki przy pierwszym doładowaniu',
  v3MoreTopUpRebates: 'Więcej rabatów i nagród z doładowań',
  v3LoginToViewOffers: 'Zaloguj się, aby zobaczyć rabaty',
  v3TopUpEnvironmentChecking: 'Sprawdzanie środowiska doładowań...',
  v3SafeToUse: 'Bezpieczne i pewne.',
  v3LimitedTimeBenefits: 'Ekskluzywna oferta ograniczona czasowo',
  v3EventRules: 'Zasady wydarzenia',
  v3MoreEvents: 'Więcej wydarzeń',
  v3Claim: 'Odbierz',
  v3Completed: 'Ukończono',
  v3GoTo: 'Idź',
  v3ViewDetails: 'Zobacz szczegóły',
  v3RecommendedProducts: 'Polecane przedmioty',
  v3SearchProductName: 'Wyszukaj po nazwie przedmiotu',
  v3AllCategories: 'Wszystko',
  v3PopularSort: 'Gorące',
  v3PriceAscending: 'Cena ↑',
  v3PriceDescending: 'Cena ↓',
  v3DiamondBonus10Percent: 'Diament +10%',
  v3YuanbaoBonus10Percent: 'Sztabka +10%',
  v3ExtraBonus10Percent: 'Bonus: 10%',
  v3FirstTopUpDouble: 'Podwójny bonus za 1. doładowanie',
  v3FirstExtraBonus: 'Bonus za 1. zakup',
  v3ProductDetails: 'Szczegóły produktu',
  v3AddToCart: 'Dodaj do koszyka',
  v3AddedToCart: 'Dodano do koszyka',
  v3BuyNow: 'Kup teraz',
  v3NoItemsInCart: 'Nie masz jeszcze przedmiotów w koszyku',
  v3SelectedItemsN: 'Wybrane przedmioty: (${n})',
  v3RemoveFromCart: 'Usunąć z koszyka?',
  v3Yes: 'Tak',
  v3No: 'Nie',
  v3LimitOnePerPurchase: 'Ten przedmiot można kupić tylko raz na zamówienie',
  v3ItemPrice: 'Cena przedmiotu',
  v3Tax: 'Podatek',
  v3ExtraGift: 'Bonus',
  v3Total: 'Razem',
  v3ProceedToPayment: 'Zapłać',
  v3SelectCoupon: 'Wybierz kupon',
  v3UnavailableCoupons: 'Niedostępne kupony',
  v3OneCouponPerOrder: 'Jeden kupon na zamówienie',
  v3DiscountCoupon: 'Kupon rabatowy',
  v3ThresholdCoupon: 'Kupon odliczeniowy',
  v3MinSpendCoupon: 'Dostępny, gdy cena całkowita przekracza xx USD',
  v3MaxDiscountCoupon: 'Zniżka do xxxx USD',
  v3LimitedChannel: 'Ograniczone do określonych kanałów',
  v3AllChannels: 'Dostępny dla wszystkich kanałów',
  v3SpecificProducts: 'Tylko dla określonych przedmiotów',
  v3AllProducts: 'Dla wszystkich przedmiotów',
  v3NotYetTimeToUse: 'Jeszcze niedostępny',
  v3Expired: 'Wygasł',
  v3Used: 'Użyty',
  v3ValidityPeriod: 'Ważność:',
  v3ConfirmUse: 'Potwierdź',
  v3ChangeProduct: 'Zmień przedmiot',
  v3ConfirmPaymentOrder: 'Potwierdź zamówienie',
  v3StoredValueRole: 'Postać do doładowania',
  v3TotalNProducts: 'Liczba przedmiotów: ${n}',
  v3SelectPaymentMethod: 'Wybierz metodę płatności',
  v3PayNow: 'Zapłać teraz',
  v3MorePaymentMethods: 'Więcej metod płatności',
  v3NoAvailablePaymentMethodContactSupport:
    'Nie możesz znaleźć dostępnych metod płatności? Skontaktuj się z Obsługą Klienta.',
  v3AvailableCoupons: 'Dostępne kupony',
  v3Extra10Percent: '0.1',
  v3LastSelection: 'Poprzedni wybór',
  v3RecommendedUsage: 'Polecane',
  v3PopularChoice: 'Popularny wybór',
  v3PaymentSuccess: 'Płatność zakończona',
  v3PaymentFailure: 'Nie udało się zapłacić',
  v3TopUpFailureMessage:
    'Niestety, doładowanie nie powiodło się. Spróbuj ponownie złożyć zamówienie lub skontaktuj się z obsługą klienta.',
  v3Game: 'Gra',
  v3UID: 'UID',
  v3OrderNumber: 'Nr zamówienia',
  v3ProductContent: 'Szczegóły przedmiotu',
  v3ViewProductDetails: 'Zobacz szczegóły przedmiotu',
  v3PaymentMethod: 'Metoda płatności',
  v3Complete: 'Zakończ',
  v3TopUpAgain: 'Doładuj ponownie',
  v3FriendlyReminderSaveOrderInfo:
    'Przypomnienie: Zapisz informacje o zamówieniu za pomocą zrzutu ekranu, aby przyspieszyć przetwarzanie.',
  v3RechargeAgain: 'Doładuj ponownie',
  v3TransactionInProgress: 'Przetwarzanie transakcji',
  v3CompletePaymentInChannel:
    'Przejdź do kanału płatności, aby zakończyć płatność.',
  v3RestAssuredFastDeliveryAfterPayment:
    'Przedmiot zostanie wysłany po otrzymaniu wyniku płatności.',
  v3SaveOrderInfoForProgress:
    'Możesz zrobić zrzut ekranu informacji o zamówieniu, aby śledzić postęp transakcji.',
  v3PaymentCompleted: 'Płatność została zakończona',
  v3AddToHomeScreen: 'Dodaj do ekranu startowego',
  v3AddShortcutForBonus: 'Dodaj skrót, aby otrzymać dodatkowe nagrody',
  v3ShareSuccess: 'Udostępniono',
  v3ShareFailure: 'Nie udało się udostępnić',
  v3RewardClaimed: 'Nagroda odebrana',
  v3RewardClaimFailed: 'Nie udało się odebrać nagrody',
  v3EventNotStarted: 'Wydarzenie jeszcze się nie rozpoczęło',
  v3EventEnded: 'Wydarzenie zakończone',
  v3ClickSelectCoupon: 'Kliknij, aby wybrać kupon',
  v3CouponsRecommendedUsed: 'Użyto polecany kupon',
  v3CouponsSelected: 'Wybrany kupon',
  v3NoCouponsAvaliable: 'Brak dostępnych kuponów',
  v3SupplementStatus: 'Status',
  v3SupplementNormal: 'Normalny',
  v3SupplementBanned: 'Zablokowany',
  v3SupplementPendingPayment: 'Oczekująca płatność',
  v3SupplementSwitchCharacter: 'Zmień postać',
  v3SupplementAccountInfoInvalid: 'Nieprawidłowe informacje o koncie',
  v3SupplementContactGSForTopUpLink:
    'Skontaktuj się z GS, aby uzyskać link do doładowania',
  v3SupplementTopUpCompleted: 'Doładowanie zakończone:',
  v3SupplementTotalRefundOrders: 'Łącznie {} zamówień zwrotu',
  v3SupplementPendingSupplementAmount: 'Kwota oczekującej płatności:',
  v3SupplementAccountCharacterNormalNoPaymentNeeded:
    'Konto/postać normalne, nie wymaga płatności',
  v3SupplementEnjoyYourGame: 'Miłej gry!',
  v3SupplementOrderInformation: 'Informacje o zamówieniu',
  v3SupplementPendingPaymentAmount: 'Kwota do zapłaty:',
  v3LookUpCouponRule: 'Sprawdź Zasady Dystrybucji Kuponów',
  v3SwitchOldVersion: 'Przejdź na starą platformę płatności',
  v3FirstTopUpGiveaway: 'Bonus 1. Doładowania',
  v3SecureConnection: 'Nawiązywanie bezpiecznego połączenia',
  v3RequestTimeOut:
    'Przekroczono limit czasu ładowania, spróbuj ponownie później.',
  v3ConfirmLeave: 'Wyjść?',
  v3NoSubmitOrder:
    'Twój koszyk nie został jeszcze opłacony, możesz stracić wybrane przedmioty, jeśli teraz wyjdziesz.',
  v3ContinueSubmit: 'Kontynuuj',
  v3LeaveSubmit: 'Wyjdź',
  v3RecentBug: 'Ostatnie zakupy',
  v3PwaTapShareOrMenuIcon: 'Kliknij ikonę Udostępnij lub Menu na pasku narzędzi przeglądarki',
  v3PwaFindAndTapAddToHomeScreen: 'Znajdź i kliknij „Dodaj do ekranu głównego" w opcjach',
  v3LaunchFromDesktopAndRewardToMailbox: 'Please launch from the desktop\nSelect a character and the reward will be sent to your mailbox',
  v3ClaimSuccessCheckMailbox: 'Odebrano pomyślnie\nSprawdź swoją skrzynkę pocztową w grze'
};
